"use client";

import { useAction } from "@rangojs/router/client";
import { addToCart } from "../actions/cart.js";
import { useVariant } from "./VariantProvider.js";
import { ProductPrice } from "./ProductPrice.js";

function AddToCartButton() {
  const { state } = useAction(addToCart);
  const isLoading = state === "loading";
  const { variant, allSelected, productId, product, orderable } = useVariant();
  const hasVariants = (product.variationAttributes?.length ?? 0) > 0;
  const isSimpleProduct = product.type?.item || product.type?.variant;

  if (isSimpleProduct && !hasVariants) {
    return (
      <form action={addToCart}>
        <input type="hidden" name="productId" value={product.id} />
        <input type="hidden" name="quantity" value="1" />
        <button
          type="submit"
          disabled={isLoading}
          className="w-full rounded bg-slate-900 px-6 py-3 text-sm font-medium text-white hover:bg-slate-800 disabled:opacity-50"
        >
          {isLoading ? "Adding..." : "Add to Basket"}
        </button>
      </form>
    );
  }

  if (!hasVariants) {
    return (
      <button
        type="button"
        disabled
        className="w-full rounded bg-slate-300 px-6 py-3 text-sm font-medium text-slate-500"
      >
        Unavailable
      </button>
    );
  }

  return (
    <form action={addToCart}>
      <input type="hidden" name="productId" value={productId ?? ""} />
      <input type="hidden" name="quantity" value="1" />
      <button
        type="submit"
        disabled={isLoading || !productId || !allSelected || (variant != null && !orderable)}
        className="w-full rounded bg-slate-900 px-6 py-3 text-sm font-medium text-white hover:bg-slate-800 disabled:opacity-50"
      >
        {isLoading
          ? "Adding..."
          : !allSelected
            ? "Select Options"
            : !orderable
              ? "Out of Stock"
              : "Add to Basket"}
      </button>
    </form>
  );
}

/** Product name + price — reads from variant context */
export function VariantDetail() {
  const { product, price, currency, productId } = useVariant();

  return (
    <div>
      <h1 className="text-2xl font-semibold text-slate-900">{product.name}</h1>

      {price != null && (
        <ProductPrice productId={productId ?? product.id} price={price} currency={currency} />
      )}
    </div>
  );
}

/** Buy form — reads from variant context */
export function VariantBuyForm() {
  const { product } = useVariant();

  return (
    <div className="mt-8">
      <AddToCartButton />

      {product.longDescription && (
        <div className="mt-8 border-t border-slate-200 pt-6">
          <h2 className="mb-3 text-sm font-medium text-slate-900">Description</h2>
          <div
            className="prose prose-sm text-slate-600"
            dangerouslySetInnerHTML={{ __html: product.longDescription }}
          />
        </div>
      )}
    </div>
  );
}
